module.exports = __webpack_public_path__ + "img/rad-conv-Sala-Analogico-HF-6.b1f7b9a4.png";